"use strict";
// (C) 2020-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrokenAlertDateFilter = exports.isBrokenAlertAttributeFilter = void 0;
function isBrokenAlertAttributeFilter(obj) {
    var _a;
    return ((_a = obj) === null || _a === void 0 ? void 0 : _a.type) === "attribute";
}
exports.isBrokenAlertAttributeFilter = isBrokenAlertAttributeFilter;
function isBrokenAlertDateFilter(obj) {
    var _a;
    return ((_a = obj) === null || _a === void 0 ? void 0 : _a.type) === "date";
}
exports.isBrokenAlertDateFilter = isBrokenAlertDateFilter;
//# sourceMappingURL=types.js.map